module.exports = __webpack_public_path__ + "img/dada.4188fe90.jpg";